import LogoLink from '@/components/logo-link';
import { useI18n } from '@/lib/i18n';
import { CheckIcon, ChevronRightIcon } from '@heroicons/react/24/outline';
import { BoltIcon } from '@heroicons/react/24/solid';
import Arrow from '@images/Arrow.svg';

export default function BenefitsSection() {
  const { t, tArr, formatNumber, cheapestPrice } = useI18n();

  return (
    <section className="relative bg-white">
      <div className="mx-auto max-w-screen-lg p-6 md:py-12 lg:py-20">
        <h2 className="text-center text-4xl font-semibold tracking-tight text-balance text-black sm:text-6xl">{t('layout.Why choose us?')}</h2>

        <p className="mx-auto mt-8 max-w-prose text-center text-lg font-medium text-pretty sm:text-xl">{t('layout.choose_us_text')}</p>

        <div className={'bg-secondary/10 mx-auto mt-6 max-w-xl self-start rounded-lg p-6 md:mt-20 md:rounded-4xl'}>
          <div className={'relative hidden justify-center py-4 md:flex'}>
            <LogoLink large={true} />
          </div>

          <div className="grid gap-4 md:mt-4">
            {tArr<{ title: string; description: string; competitors: string }>('components.benefits').map((benefit, n) => (
              <div key={n} className="flex">
                <CheckIcon className={'bg-secondary mr-4 size-7 rounded-xl p-1 text-black'} />
                <div className={'flex-1'}>
                  <h3 className="text-lg font-semibold">{benefit.title}</h3>
                  <p className="mt-2">{benefit.description}</p>
                  <p className="mt-2 text-sm italic">{benefit.competitors}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-8 flex flex-col items-center justify-center gap-6 md:flex-row">
          <a href="#products" className="bg-secondary relative flex items-center rounded-xl px-3.5 py-3 hover:opacity-75 md:text-base">
            <img src={Arrow} alt={'Arrow'} className={'pointer-events-none absolute top-0 right-full h-8 w-auto -translate-y-10 rotate-45'} />
            <BoltIcon className={'mr-3 size-8'} />
            <div className={'text-left'}>
              <div className={'font-semibold text-black'}>{t('layout.Choose product')}</div>
              <div className={'text-sm leading-none text-black'}>{t('layout.From :price', { price: formatNumber(cheapestPrice, true) })}</div>
            </div>
            <ChevronRightIcon className={'ml-6 size-6 text-yellow-800'} />
          </a>
        </div>
      </div>
    </section>
  );
}
